import { textAtomTypeId } from '@/enums';
import { useEntityTextSave } from './useEntityTextSave';

interface UpdateActLoglineData {
    actId: number;
    content: string;
    textAtomId?: number;
}

export function useUpdateActLogline() {
    return useEntityTextSave<UpdateActLoglineData>({
        entity: 'act',
        action: 'updateLogline',
        typeId: textAtomTypeId.act_logline,
        entityIdOf: ({ actId }) => actId,
    });
}
